import request from '@/services/interceptor.js'

// Registro di sintesi personalizzato. Le anagrafiche (gruppi di prodotto, dichiarazioni FSC, essenze,
// unita' di misura) restano quelle del registro FSC: vedi api.registroSintesi.js

export const get_verifica_accesso = (companyCode) => {
    return request({
        url: '/registrosintesipers/accesso?companyCode=' + companyCode,
        method: 'get',
        loadingBar: false
    })
}

// Variante del registro dell'azienda ("CARTONE" | "LEGNO"); vuota se il registro non e' abilitato
export const get_config = (par = "") => {
    return request({
        url: '/registrosintesipers/config' + par,
        method: 'get',
        loadingBar: false
    })
}

//#region Materie prime in ingresso
export const get_materiali = (par = "") => {
    return request({
        url: '/registrosintesipers/materiali' + par,
        method: 'get',
        loadingBar: true
    })
}

export const get_materiali_disponibili = (par = "") => {
    return request({
        url: '/registrosintesipers/materiali-disponibili' + par,
        method: 'get',
        loadingBar: true
    })
}

export const set_materiale = (data) => {
    return request({
        url: '/registrosintesipers/materiale',
        method: 'post',
        data: data,
        loadingBar: true
    })
}

export const del_materiale = (data) => {
    return request({
        url: '/registrosintesipers/materiale',
        method: 'delete',
        data: data,
        loadingBar: true
    })
}
//#endregion

//#region Commesse in uscita
export const get_log_commesse = (par = "") => {
    return request({
        url: '/registrosintesipers/log-commesse' + par,
        method: 'get',
        loadingBar: true
    })
}

export const set_commessa = (data) => {
    return request({
        url: '/registrosintesipers/log-commesse',
        method: 'post',
        data: data,
        loadingBar: true
    })
}

export const del_commessa = (data) => {
    return request({
        url: '/registrosintesipers/log-commesse',
        method: 'delete',
        data: data,
        loadingBar: true
    })
}
//#endregion

//#region Declassamento
export const salva_declassamento = (data) => {
    return request({
        url: '/registrosintesipers/declassamento',
        method: 'post',
        data: data,
        loadingBar: true
    })
}

export const get_storico_declassamento = (par = "") => {
    return request({
        url: '/registrosintesipers/declassamento/storico' + par,
        method: 'get',
        loadingBar: true
    })
}

export const salva_storico_declassamento = (data, method) => {
    return request({
        url: '/registrosintesipers/declassamento/storico',
        method: method,
        data: data,
        loadingBar: true
    })
}
//#endregion

export const esporta_dati = (data) => {
    return request({
        url: '/registrosintesipers/esporta-dati',
        method: 'post',
        data: data,
        loadingBar: true
    })
}
